// components
import maEventbus from '@/components/eventbus'
import maModal from '@/components/modal'
import maPoligons from '@/components/poligons'
import maInput from '@/components/input'

/**
 * @module
 * @name InputTextmapline
 * @description Input that shows a map and emit and event when a distance are
 *              set on top of the map. (JUST FOR DISTANCE, see inputTextmapline)
 */
export default {
  name: 'InputTextMapLine',
  /**
   * @function
   * @property {Float|String} mapValue Value of the measure done on the map.
   */
  data: function () {
    return {
      mapValue: this.value || ''
    }
  },

  /**
   * @property {Float} coordinates.lat Lat coordinate.
   * @property {Float} coordinates.lng Lng coordinate.
   */
  props: {
    coordinates: {
      type: Object
    }
  },

  /**
   * @property {Float} lat Lat coordinate.
   * @property {Float} lng Lng coordinate.
   */
  computed: {
    lat: function () {
      return this.coordinates ? this.coordinates.lat : null
    },
    lng: function () {
      return this.coordinates ? this.coordinates.lng : null
    }
  },

  extends: maInput,
  components: {
    maModal,
    maPoligons
  },

  methods: {
    /**
     * @function
     * @name handleShowModal
     * @description Shows map modal.
     */
    handleShowModal: function () {
      this.$refs[`input${this.type}${this.name}`].showModal = true
    },

    /**
     * @function
     * @name handlePolygonChange
     * @param {Float} v Value set from the map.
     */
    handlePolygonChange: function (v) {
      this.mapValue = v
      this.$refs[`input${this.type}${this.name}`].showModal = false
    }
  },

  /**
   * @function
   * @name mounted
   * @fires map:update
   */
  mounted: function () {
    maEventbus.$on('map:update', coordinates => {
      /**
       * @event
       * @name map:update
       * @description Emit coordinates got on the map.
       */
      this.lat = coordinates.lat
      this.lng = coordinates.lng
    })
  },

  /**
   * @property {function} mapValue If mapValue, value is emitted to parent compo.
   */
  watch: {
    mapValue: function (newV, oldV) {
      this.$emit('change', newV)
    }
  }
}
